import { apiService } from '../services/api';

export interface ActiveRun {
  id: number;
  status: string;
  created_at: string;
  html_url: string;
}

/**
 * triggerBuild result:
 *   alreadyRunning: false → dispatch succeeded, modal should close
 *   alreadyRunning: true  → run in progress, modal switches to countdown view
 */
export interface TriggerResult {
  alreadyRunning: boolean;
  activeRun?: ActiveRun;
}

export async function triggerBuild(
  siteTokenId: number,
  tag: string,
): Promise<TriggerResult> {
  const { active, run } = await apiService.getWorkflowStatus();
  if (active && run) {
    return { alreadyRunning: true, activeRun: run as ActiveRun };
  }
  await apiService.triggerBuild(siteTokenId, tag);
  return { alreadyRunning: false };
}
